import { Controller } from "@hotwired/stimulus"

// Switches an element's variant in place (preview, HTML code and the combined copy). The chips stay real
// ?variant= links, so they work without JavaScript and can be opened in a new tab or shared.
export default class extends Controller {
  static targets = ["chip", "combined"]
  static values = { css: String }

  choose(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return
    event.preventDefault()
    const { html } = event.params
    this.element.querySelector(".ui-stage-content").innerHTML = html
    this.element.querySelector("#element-html code").textContent = html
    if (this.hasCombinedTarget) this.combinedTarget.value = `<style>\n${this.cssValue}\n</style>\n\n${html}`
    this.chipTargets.forEach((chip) => {
      if (chip === event.currentTarget) chip.setAttribute("aria-current", "true")
      else chip.removeAttribute("aria-current")
    })
    history.replaceState(history.state, "", event.currentTarget.href)
  }
}
